/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios';
import i18next from 'i18next';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getToken } from 'datastake-daf/src/helpers/Token';
import { WidgetLoader } from 'datastake-daf/dist/components';
import { getAppHeader, getApiBaseUrl } from '../../../services/BaseService';

const placeholder = () => (
  <span className="text-muted">{i18next.t('Not answered')}</span>
);

const endpoint = `${getApiBaseUrl()}/scl/getAssociatedMineSites`;

const calls = {
  village: {
    associatedMiningSites: {
      endpoint: (id) => `${endpoint}?id=${id}`,
    },
  },
}

const renderOption = (options = [], data = '') => {
  const val = options.find((o) => o.value === data);

  if (val) {
    return val.label;
  }

  return placeholder();
}

const Table = ({
  config = {},
  subjectData = {},
  extraRequestSent = false,
  setExtraRequestSent = () => { },
  loading = true,
  setLoading = () => { },
  data = [],
  setData = () => { },
}) => {
  const { t } = useTranslation();
  const { columns, namespace, key, title } = config;
  const percentage = 100 / columns.length;

  useEffect(() => {
    if (!extraRequestSent) {
      const groupCalls = calls[namespace];
      if (groupCalls) {
        const call = groupCalls[key];
        if (call && typeof call.endpoint === 'function') {
          setExtraRequestSent(true);
          axios.get(call.endpoint(subjectData.datastakeId), {
            headers: {
              Authorization: `Bearer ${getToken()}`,
              ...getAppHeader(),
            },
          })
            .then(({ data }) => {
              setData(data);
              setLoading(false);
            });
        }
      }
    }
  }, [subjectData]);

  return (
    <div className="group-extra repeatable" style={{ position: 'relative' }}>
      <div className="title">
        <h1>{title}</h1>
      </div>
      {loading && <WidgetLoader background="white" />}
      {columns.map((c, i) => (
        <div
          key={`${c.key}-${i}`}
          className="input"
          style={{ width: `calc(${percentage}% - 0px)` }}
        >
          <p className="label">
            <span>{t(c.label)}</span>
          </p>
        </div>
      ))}
      {data.length ? data.map((d, i) => (
        <div className="repeatable-row" key={`${key}-rows-${i}`}>
          {columns.map((col, j) => (
            <div className="input"
              style={{ width: `calc(${percentage}% - 0px)` }}
              key={`${key}-rows-${col.key}`}
            >
              <p className="value">
                {col.options ? renderOption(col.options, d[col.key]) : d[col.key] || placeholder(t)}
              </p>
            </div>
          ))}
        </div>
      )) : (
        <div className="repeatable-row">
          {columns.map((col) => (
            <div className="input"
              style={{ width: `calc(${percentage}% - 0px)` }}
              key={`${key}-rows-${col.key}`}
            >
              <p className="value">{placeholder(t)}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default function ExtraLinkingData({
  config = [],
  data = {},
  extraRequestSent = () => { },
  setExtraRequestSent = () => { },
  extraRequestLoading = () => { },
  setExtraRequestLoading = () => { },
  extraRequestData = {},
  setExtraRequestData = () => { },
}) {
  const setLoading = (key, val) => {
    setExtraRequestLoading((prev) => ({ ...prev, [key]: val }));
  };

  const setData = (key, val) => {
    setExtraRequestData((prev) => ({ ...prev, [key]: val }));
  };

  const setRequestSent = (key, val) => {
    setExtraRequestSent((prev) => ({ ...prev, [key]: val }));
  };

  const renderItem = (config) => {
    switch (config.component) {
      case 'TABLE':
        return <Table
          key={config.key}
          config={config}
          extraRequestSent={extraRequestSent[config.key]}
          setExtraRequestSent={(val) => setRequestSent(config.key, val)}
          subjectData={data}
          loading={extraRequestLoading[config.key]}
          setLoading={(val) => setLoading(config.key, val)}
          data={extraRequestData[config.key]}
          setData={(val) => setData(config.key, val)}
        />
      default:
        return null;
    }
  }

  return config.map((c) => renderItem(c));
}
